import React from 'react'

function AppFooter() {
    return (
        <footer className="main-footer">
            <strong>Copyright © 2025 <a href="#">{process.env.REACT_APP_NAME}</a>.</strong> All rights reserved.
        </footer>
    )
}

export default AppFooter